import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { selectSelf } from '.'
import { CopiedDataState } from '../reducers/copiedData'

export const selectCopiedDataState = createSelector(selectSelf, (state: RootState) => state.copiedData)
export const selectCopiedData = () => createSelector(selectCopiedDataState, (state: CopiedDataState) => state?.data)
